import { C32IconCTAColoredBoxProps } from './C32IconCTAColoredBox';
import { C32IconCTAColoredBoxCardProps } from './C32IconCTAColoredBoxCard';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { IconCtaColoredBoxCardProps, IconCtaColoredBoxProps } from '@ahc-digital/component-library';
import { ICON_CTA_COLORED_BOX_CARDS } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function CreateIconCTAColoredBoxModel(props?: C32IconCTAColoredBoxProps) {
  type t = IconCtaColoredBoxProps;
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderText } = useConditionalRendering();
  return {
    headline: renderText(fields?.Headline) as t['headline'],
    supportCopy: renderRichText(fields?.SupportCopy) as t['supportCopy'],
    bottomSupportCopy: renderRichText(fields?.BottomSupportCopy) as t['bottomSupportCopy'],
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'p'),
    columns: getDroplink<t['columns']>(params?.NumberOfColumns, '2'),
    supportCopyAlignment: getDroplink<t['supportCopyAlignment']>(
      params?.SupportCopyAlignment,
      'center'
    ),
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.TitleAlignment, 'center'),
    children: rendering && <Placeholder name={ICON_CTA_COLORED_BOX_CARDS} rendering={rendering} />,
  };
}

export function CreateIconCTAColoredBoxCardModel(props?: C32IconCTAColoredBoxCardProps) {
  type t = IconCtaColoredBoxCardProps;
  const { params, fields } = props || {};
  const { renderRichText, renderText, renderLink } = useConditionalRendering();
  return {
    icon: props?.fields?.Icon?.fields?.Value?.value as t['icon'],
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'p'),
    headline: renderText(fields?.Headline) as t['headline'],
    supportCopy: renderRichText(fields?.SupportCopy) as t['supportCopy'],
    cardCTA: renderLink(fields?.CardCTA) as t['cardCTA'],
  };
}
